export default function PreconAuthIcon() {
  return "📋";
}
